class BundleCartAdd extends CustomElement {
  props = {
    children: [],
  }

  init() {
    super.init();
    this.form = this.querySelector("form");
    this.submitButton = this.querySelector('[type="submit"]');
    this.variantRadios = document.querySelector("variant-radios");
  }

  mounted() {
    this.form.addEventListener("submit", this.onSubmit.bind(this));
    document.addEventListener("change", this.updateAvailability.bind(this));
    this.updateAvailability();
  }

  getPlaceholderSelectedValues() {
    const selected = {};
    if (!this.variantRadios) return selected;
    this.variantRadios.querySelectorAll('fieldset[data-test^="fieldset-"]').forEach((fieldset) => {
      const optionKey = fieldset.dataset.test.replace("fieldset-", "");
      const checked = fieldset.querySelector("input:checked");
      if (checked) selected[optionKey] = checked.value;
    });
    return selected;
  }

  matchChildVariant(child, selectedValues) {
    if (!Array.isArray(child.variants) || !Array.isArray(child.optionNames)) return null;

    const constraints = child.optionNames
      .map((name, index) => ({ index, value: selectedValues[name.toLowerCase()] }))
      .filter((constraint) => constraint.value != null);
    if (constraints.length === 0 || constraints.length < child.optionNames.length) return null;

    return (
      child.variants.find((variant) =>
        constraints.every((constraint) => variant[`option${constraint.index + 1}`] === constraint.value),
      ) || null
    );
  }

  resolveItems() {
    const selected = this.getPlaceholderSelectedValues();
    return this.props.children.map((child) => {
      const matchedVariant = this.matchChildVariant(child, selected);
      const id = matchedVariant ? matchedVariant.id : child.variantId;
      const available = matchedVariant ? matchedVariant.available : child.available;
      return { id, quantity: child.quantity, available };
    });
  }

  hasInvalidState() {
    const items = this.resolveItems();
    return items.some((item) => !item.id || item.available === false);
  }

  updateAvailability() {
    const invalid = this.hasInvalidState();
    this.submitButton.toggleAttribute("disabled", invalid);
    this.submitButton.setAttribute("aria-disabled", String(invalid));
    this.handleErrorMessage(invalid ? this.dataset.childUnavailableMessage : false);
  }

  onSubmit(evt) {
    evt.preventDefault();

    if (this.hasInvalidState()) {
      this.updateAvailability();
      return;
    }

    this.submitButton.setAttribute("aria-disabled", "true");
    this.submitButton.setAttribute("disabled", "disabled");
    this.submitButton.classList.add("loading");
    this.querySelector(".loading-overlay__spinner")?.classList.remove("!hidden");
    if (typeof setStickyAdding === "function") setStickyAdding(true, this);

    const items = this.resolveItems().map(({ id, quantity }) => ({ id, quantity }));
    const config = fetchConfig("javascript");
    config.body = JSON.stringify({ items });

    fetch(routes.cart_add_url, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          this.handleErrorMessage(response.description || this.dataset.addToCartErrorMessage);
          publish(PUB_SUB_EVENTS.cartError, {
            source: "bundle-cart-add",
            productVariantId: items[0]?.id,
            errors: response.description,
            message: response.message,
          });
          return;
        }

        this.handleErrorMessage(false);
        publish(PUB_SUB_EVENTS.cartUpdate, { source: "bundle-cart-add" });

        if (typeof window.handleFloCartBtn === "function") {
          window.handleFloCartBtn();
        }
      })
      .catch((error) => {
        console.error(error);
        this.handleErrorMessage(this.dataset.addToCartErrorMessage);
      })
      .finally(() => {
        this.submitButton.classList.remove("loading");
        this.querySelector(".loading-overlay__spinner")?.classList.add("!hidden");
        if (typeof setStickyAdding === "function") setStickyAdding(false, this);
        if (!this.hasInvalidState()) {
          this.submitButton.removeAttribute("aria-disabled");
          this.submitButton.removeAttribute("disabled");
        }
      });
  }

  handleErrorMessage(message) {
    this.errorWrapper = this.errorWrapper || this.querySelector(".product-form__error-message-wrapper");
    this.errorMessage = this.errorMessage || this.querySelector(".product-form__error-message");
    if (!this.errorWrapper || !this.errorMessage) return;

    this.errorWrapper.toggleAttribute("hidden", !message);
    if (message) this.errorMessage.textContent = message;
  }
}

customElements.define("bundle-cart-add", BundleCartAdd);
